import React from "react";
import { useStoreState } from 'easy-peasy';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

const RelationTypeFormComponent = ({ relationType = null }) => {
    const { apiData: { ACTIONS } } = useStoreState(state => state.actionSlugs);
    const token = ACTIONS.clientRelationTypes[relationType ? 'update' : 'create'].csrfToken;

    return (
        <div>
            <div>
                <Form id="relationType-form">
                    <Form.Group>
                        <Form.Label>Nom :</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            defaultValue={relationType?.name ?? ""}
                        />
                        <Form.Control.Feedback type='invalid' name='feedback-name'></Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group >
                        <Form.Control
                            name="csrfToken"
                            defaultValue={token}
                            type="hidden"
                        />
                    </Form.Group>
                </Form>
            </div>
        </div>

    );
};

export const submitRelationTypeForm = ({ relationType, allRelationTypes, action }) => {
    let error = false;

    let formData = new FormData(document.getElementById('relationType-form'));

    let name = formData.get('name');

    document.getElementsByName('name')[0].classList.remove("is-invalid");

    if (name === "") {
        document.getElementsByName('name')[0].classList.add("is-invalid");
        document.getElementsByName(`feedback-name`)[0].innerHTML = "Le nom de la nature de la relation est obligatoire";
        error = true;
    }
    if (name && allRelationTypes.find(rT => rT.name.toLowerCase() === name.toLowerCase() && rT.uniqueId !== relationType?.uniqueId)) {
        document.getElementsByName('name')[0].classList.add("is-invalid");
        document.getElementsByName(`feedback-name`)[0].innerHTML = "Ce nom de nature de la relation existe déjà";
        error = true;
    }

    if (error) {
        return Promise.reject(new Error());
    } else {
        let data = { name: formData.get('name'), csrfToken: formData.get('csrfToken') }

        if (relationType) {
            data = { data: data, uniqueId: relationType.uniqueId }
        } else {
            const valueFromName = data.name.toLowerCase()
                ?.split(' ')
                ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
                ?.join('');
            data.value = valueFromName;
        }

        return action(data)
            .catch(() => {
                return Promise.reject(new Error());
            })
    }
}

RelationTypeFormComponent.propTypes = {
    relationType: PropTypes.object
};
export default RelationTypeFormComponent;